import { he } from "date-fns/locale";

export const dictionary = [
    {
        key: 'contact_us',
        en: 'Contact Us',
        he: 'צור קשר',
    },
    {
        key: 'about_us',
        en: 'About Us',
        he: 'אודותינו',
    },
    {
        key: 'doctors',
        en: 'Doctors',
        he: 'רופאים',
    },
    {
        key: 'login',
        en: 'Login',
        he: 'התחבר',
    },
    {
        key: 'register',
        en: 'Register',
        he: 'הרשם',
    },
    {
        key: 'home_banner_t1',
        en: 'Mashlim',
        he: 'משלים',
    },
    {
        key: 'home_banner_t2',
        en: 'what you really need',
        he: 'מה שאתה באמת צריך',
    },
    {
        key: 'home_banner_st1',
        en: '',
        he: 'כתב שירות משלים שחייב לכל גיל',
    },
    {
      key: 'plans_subTitle',
      en: '',
      he: 'בחר את המסלול עבורך ותהנה מעד 70% החזר על כל טיפול או בדיקה',
  },
    {
        key: 'register_now',
        en: 'Register Now',
        he: 'הרשם עכשיו',
    },

    {
        key: 'our_doctors',
        en: 'Our Doctors',
        he: 'הרופאים שלנו',
    },

    {
        key: 'book_appointment',
        en: 'Book Appointment',
        he: 'קבע תור',
    },
    {
        key: 'consultation',
        en: 'Consultation',
        he: 'ייעוץ',
        
    },
    {
        key: 'testing_labs',
        en: 'Testing Labs',
        he: 'מעבדות בדיקה',
    },
    {
        key: 'diagnostic_tests',
        en: 'Diagnostic Tests',
        he: 'בדיקות אבחנתיות',
    },
    {
        key:"pregnancy_basket",
        en: "Pregnancy Basket",
        he: "סל הריון",
    },
    {
        key:"pain_clinic",
        en: "Pain Clinic",
        he: "מרפאות כאב",
      
    },
    {
        key:"physiotherapy",
        en: "Physiotherapy",
        he: "פיזיותרפיה",
    },
    {
        key:"online_doctor",
        en: "Online Doctor",
        he: "רופא אונליין",
    },
    
    {
        key: 'medicines',
        en: 'Medicines',
        he: 'תרופות',
    },
    {
        key: 'clinics',
        en: 'Clinics',
        he: 'מרפאות',
    },
    {
        key: 'health_care',
        en: 'Health Care',
        he: 'טיפול רפואי',
    },
    {
        key: 'talk_to_doctor',
        en: 'Talk to Doctor',
        he: 'שוחח עם רופא',
    },
    {
        key: 'home_care_service',
        en: 'Home Care Service',
        he: 'שירות טיפול ביתי',
    },
    {
        key: 'specialities',
        en: 'Specialities',
        he: 'המומחיות שלנו:',
    },
    {
        key: 'speciality_cardiology',
        en: 'Cardiology',
        he: 'קרדיולוגיה',
    },
    {
        key: 'speciality_neurology',
        en: 'Neurology',
        he: 'נוירולוגיה',
    },
    {
        key: 'speciality_urology',
        en: 'Urology',
        he: 'אורולוגיה',
    },
    {
        key: 'speciality_orthopedic',
        en: 'Orthopedic',
        he: 'אורתופדיה',
    },
    {
        key: 'speciality_dentist',
        en: 'Dentist',
        he: 'רופא שיניים',
    },
    {
        key: 'speciality_ophthalmology',
        en: 'Ophthalmology',
        he: 'רפואת עיניים',
    },
    {
        key: 'best_doctors',
        en: 'Best Doctors',
        he: 'הרופאים הטובים ביותר',
    },
    {
        key: 'our_contract_services',
        en: 'Our Contract Services',
        he: 'כתבי השירות שלנו',
      
    },
    {
        key: 'dr_downer',
        en: 'Dr. Downer',
        he: 'ד"ר דאונר',
    },

    {
        key: 'dr_aviles',
        en: 'Dr. Aviles',
        he: 'ד"ר אבילס',
    },

    {
        key: 'location_newyork',
        en: 'New York, USA',
        he: 'ניו יורק, ארצות הברית',
    },

    {
        key: 'dr_palmore',
        en: 'Dr. Palmore',
        he: 'ד"ר פאלמור',
    },
    {
        key: 'speciality_immunologist',
        en: 'Immunologist',
        he: 'אימונולוג',
    },
    {
        key: 'location_waipahu',
        en: 'Waipahu, HI',
        he: 'וייפהו, הוואי',
    },
    {
        key: 'availability_available',
        en: 'Available',
        he: 'זמין',
    },
    {
        key: 'dr_paul_richard',
        en: 'Dr. Paul Richard',
        he: 'ד"ר פול ריצ\'רד',
    },
    {
        key: 'pricing_plans',
        en: 'Pricing Plans',
        he: 'מסלולים',
    },
    {
        key: 'personal_plan',
        en: 'Personal',
        he: 'אישי',
    },
    {
      key: 'plus_plan',
      en: 'Plus',
      he: 'פלוס',
    },
    {
      key: 'premium_plan',
      en: 'Premium',
      he: 'פרימיום',
    },
    {
      key: 'basic_plan',
      en: 'Basic',
      he: 'בסיסי',
  },
    {
        key: 'basic_plan_desc',
        he: 'כתבי השירות משלים עד הבית ומשלים בריאות',
        en: 'Home service and health supplements',
    },
    {
      key: 'plus_plan_desc',
      he: 'כל מה שבכתבי השירות משלים בריאות ומשלים פלוס',
      en: 'All that is in the health supplements and plus supplements',
  },
  {
    key: 'premium_plan_plus_desc',
    he: 'כל מה שבכתבי השירות משלים עד הבית, משלים בריאות ומשלים פלוס',
    en: 'All that is in the home service supplements, health supplements and plus supplements',
  
},

  
    {
        key: 'family_plan',
        en: 'Family',
        he: 'משפחתי',
    },
    {
        key: 'family_plan_desc',
        en: 'For families',
        he: 'למשפחות',
    },
    {
        key: 'corporate_plan_plus',
        en: 'Corporate Plus',
        he: 'עסקי פלוס',
    },
    {
        key: 'corporate_plan_plus_desc',
        en: 'For corporate',
        he: 'לעסקים',
    },
    {
      key: 'benefit1',
      en: 'Regular checkups',
      he: 'בדיקות שגרתיות',
  },
  {
      key: 'benefit2',
      en: 'Personalized treatment',
      he: 'רופא עד הבית',
  },
    {
        key: 'benefit3',
        en: 'Emergency services',
        he: 'שירותי חירום',
    },
    {
        key: 'benefit4',
        en: '24/7 support',
        he: 'תמיכה 24/7',
    },
    {
        key: 'benefit5',
        en: 'Specialist consultation',
        he: 'ייעוץ מומחים',
    },
    {
        key: 'benefit6',
        en: 'Home care service',
        he: 'שירות טיפול ביתי',
    },
    {
        key: 'benefit7',
        en: 'Medicines',
        he: 'תרופות',
    },
    {
        key: 'benefit8',
        en: 'Testing labs',
        he: 'מעבדות בדיקה',
    },
    {
        key: 'benefit9',
        en: 'Clinics',
        he: 'מרפאות',
    },
    {
        key: 'benefit10',
        en: 'Health care',
        he: 'טיפול רפואי',
    },
    {
        key: 'benefit11',
        en: 'Talk to doctor',
        he: 'שוחח עם רופא',
    },
    {
        key: 'benefit12',
        en: 'Specialities',
        he: 'המומחיות שלנו',
    },
    {
      key: 'consult_specialist',
      en: 'Consultation with specialists',
      he: 'התייעצות עם רופאים מומחים',
    },
    {
      key: 'diagnostic_tests',
      en: 'Diagnostic tests',
      he: 'בדיקות אבחנתיות',
    },
    {
      key: 'preventive_tests',
      en: 'Preventive health tests',
      he: 'בדיקות לרפואה מונעת',
    },
    {
      key: 'screening_tests',
      en: 'Screening tests (including cancer screening)',
      he: 'בדיקות סקר (כולל סרטן)',
    },
    {
      key: 'physiotherapy',
      en: 'Physiotherapy treatments',
      he: 'טיפולי פיזיותרפיה',
    },
    {
      key: 'hydrotherapy',
      en: 'Hydrotherapy treatments',
      he: 'טיפולי הידרותרפיה',
    },
    {
      key: 'online_doctor',
      en: 'Online doctor 24/7',
      he: 'רופא אונליין 24/7',
    },
    {
      key: 'home_doctor',
      en: 'Doctor at home 24/7',
      he: 'רופא עד הבית 24/7',
    },
    {
      key: 'ambulance_service',
      en: 'Emergency ambulance service',
      he: 'פינוי באמבולנס',
    },
    {
      key: 'pain_clinics',
      en: 'Pain clinic treatments',
      he: 'טיפולים במרפאות כאב',
    },
    {
      key: 'adhd_testing',
      en: 'ADHD and learning disabilities testing for children',
      he: 'אבחון קשב וריכוז וליקויי למידה לילדים',
    },
    {
      key: 'capsule_endoscopy',
      en: 'Capsule endoscopy',
      he: 'בדיקת קפסולה אנדוסקופית',
    },
    {
      key: 'sleep_labs',
      en: 'Sleep laboratory tests',
      he: 'בדיקות במעבדות שינה',
    },
    {
      key: 'food_intolerance_tests',
      en: 'Food intolerance tests',
      he: 'בדיקות אי סבילות למזון',
    },
    {
      key: 'pregnancy_tests',
      en: 'Pregnancy-related tests',
      he: 'בדיקות הקשורות להריון',
    },
    {
      key: 'expanded_maternity',
      en: 'Expanded maternity benefits',
      he: 'סל הריון מורחב',
    },
    {
      key: 'birth_preparation',
      en: 'Birth preparation course',
      he: 'קורס הכנה ללידה',
    },
    {
      key: 'doula_service',
      en: 'Doula services',
      he: 'שירותי דולה',
    },
    {
      key: 'postpartum_hotel',
      en: 'Postpartum hotel stay',
      he: 'שהייה במלונית לאחר לידה',
    },
    {
      key: 'lactation_consultant',
      en: 'Consultation with a certified lactation consultant',
      he: 'התייעצות עם יועצת הנקה מוסמכת',
    },
    {
        key: 'whats_includes',
        en: 'What\'s Included',
        he: 'מה כלול',
    },
    {
        key: 'monthly',
        en: 'Monthly',
        he: 'לחודש',
    },
    {
      key: 'popular',
      en: 'Popular',
      he: 'הנמכר ביותר',
  },
    {
        key: 'choose_plan',
        en: 'Choose Plan',
        he: 'בחר מסלול',
    },
    {
        key: 'family_plan_plus',
        en: 'Family Plus',
        he: 'משפחתי פלוס',
    },
    {
        key: 'article1_title',
        en: 'The Key to a Healthy Lifestyle: Simple Habits for Long-Term Wellness',
        he: 'המפתח לאורח חיים בריא: הרגלים פשוטים לבריאות לטווח ארוך',
    },
    {
        key: 'tag_health_tips',
        en: 'Health Tips',
        he: 'טיפים לבריאות',
    },
    {
        key: 'tag_health',
        en: 'Health',
        he: 'בריאות',
    },
    {
        key: 'writer_elder',
        en: 'Dr. Michael Elder',
        he: 'ד"ר מייקל אלדר',
    },
    {
        key: 'article1_paragraph1_content',
        en: 'Achieving long-term wellness starts with simple, sustainable habits that nourish both body and mind. Drinking enough water daily is crucial, as hydration supports digestion, energy levels, and overall health. Aim for at least eight glasses a day to keep your body functioning optimally.',
        he: 'השגת בריאות לטווח ארוך מתחילה בהרגלים פשוטים ובריאים שמזינים את הגוף והנפש. שתייה מספקת של מים מדי יום חיונית, שכן הידרציה תומכת בעיכול, ברמות האנרגיה ובבריאות הכללית. שאפו לשתות לפחות שמונה כוסות ביום כדי לשמור על תפקוד מיטבי של הגוף.',
    },
    {
        key: 'article1_paragraph2_content',
        en: 'A nutritious diet plays a fundamental role in well-being. Focus on whole foods such as fresh fruits, vegetables, lean proteins, and whole grains. These provide essential nutrients that boost immunity, enhance energy, and promote overall health. Reducing processed foods and excess sugar intake can also have a significant impact on long-term vitality.',
        he: 'תזונה מזינה ממלאת תפקיד מרכזי ברווחה האישית. התמקדו במזונות מלאים כמו פירות וירקות טריים, חלבונים רזים ודגנים מלאים. מזונות אלו מספקים חומרים מזינים חיוניים המחזקים את מערכת החיסון, משפרים את רמות האנרגיה ותורמים לבריאות הכללית. הפחתת מזון מעובד וצריכת סוכר מופרזת יכולה להשפיע משמעותית על החיוניות לטווח הארוך.',
    },
    {
        key: 'article1_paragraph3_content',
        en: 'Consistency is the secret to lasting health improvements. Small, positive changes made daily will have a more significant impact over time than drastic short-term efforts. Commit to a balanced lifestyle, incorporating hydration, nutrition, exercise, and rest. Your future self will thank you for the effort you put in today.',
        he: 'המשכיות היא הסוד לשיפור בריאות מתמשך. שינויים קטנים וחיוביים המתבצעים מדי יום ישפיעו לאורך זמן יותר מניסיונות קיצוניים לטווח הקצר. התחייבו לאורח חיים מאוזן הכולל הידרציה, תזונה, פעילות גופנית ומנוחה. העתיד שלכם יודה לכם על המאמץ שהשקעתם היום.',
    },
    {
        key: 'article2_title',
        en: 'Building Strong Health Foundations: The Power of Daily Habits',
        he: 'בניית יסודות בריאות חזקים: כוחם של הרגלים יומיומיים',
    },
    {
        key: 'article2_paragraph1_content',
        en: 'A strong foundation for health begins with small, mindful choices each day. The way you start your morning can set the tone for the rest of the day. Drinking a glass of water upon waking helps to rehydrate your body and kickstart your metabolism. Pairing this with a nutritious breakfast, rich in protein and fiber, will provide sustained energy and prevent mid-morning fatigue.',
        he: 'יסודות בריאות חזקים מתחילים בבחירות קטנות ומודעתות בכל יום. הדרך בה אתם מתחילים את הבוקר שלכם יכולה לקבוע את הטון לשאר היום. שתיית כוס מים מיד עם ההתעוררות מסייעת להידרציה ומעוררת את חילוף החומרים. שילוב זאת עם ארוחת בוקר מזינה, עשירה בחלבון וסיבים תזונתיים, יספק אנרגיה מתמשכת וימנע עייפות בשעות הבוקר המאוחרות.',
    },
    {
        key: 'article2_paragraph2_content',
        en: 'Mindfulness and stress management play a vital role in long-term well-being. Taking short breaks throughout the day to breathe deeply and refocus your thoughts can enhance mental clarity and productivity. Practicing gratitude or journaling for a few minutes daily helps cultivate a positive mindset, reducing the impact of stress on both your body and mind.',
        he: 'מודעות וניהול מתחים ממלאים תפקיד חשוב ברווחה לטווח הארוך. הפסקות קצרות במהלך היום לנשימה עמוקה והתמקדות מחדש יכולות לשפר את בהירות המחשבה והתפוקה. תרגול הכרת תודה או כתיבת יומן למספר דקות ביום מסייעים לטפח חשיבה חיובית, וכך להפחית את השפעת הלחץ על הגוף והנפש.',
    },
    {
        key: 'article2_paragraph3_content',
        en: 'Sustainable health isn’t about drastic measures, but rather about consistency. Small changes, such as walking more, staying hydrated, and eating whole foods, accumulate into a healthier lifestyle over time. When you approach wellness as a lifelong journey, rather than a temporary goal, you create lasting benefits that support your overall happiness and vitality.',
        he: 'בריאות ברת קיימא אינה מושגת באמצעות צעדים דרסטיים, אלא דרך התמדה. שינויים קטנים, כמו הליכה מרובה יותר, שמירה על הידרציה ואכילת מזון מלא, מצטברים לכדי אורח חיים בריא לאורך זמן. כאשר רואים את הבריאות כמסע מתמשך ולא כיעד זמני, יוצרים יתרונות מתמשכים התומכים באושר ובחיוניות שלכם.',
    },
    {
        key: 'article3_title',
        en: 'Small Steps, Big Impact: Simple Ways to Improve Your Health',
        he: 'צעדים קטנים, השפעה גדולה: דרכים פשוטות לשיפור הבריאות',
    },
    {
        key: 'article3_paragraph1_content',
        en: 'Improving your health doesn’t require extreme changes—small daily habits can make a big difference. One of the easiest ways to boost your well-being is by increasing your daily movement. Whether it’s taking the stairs instead of the elevator, stretching in the morning, or going for a short walk after meals, every step counts toward better health.',
        he: 'שיפור הבריאות שלכם לא מחייב שינויים קיצוניים - הרגלים יומיומיים קטנים יכולים להשפיע משמעותית. אחת הדרכים הקלות לשיפור הרווחה האישית היא על ידי הגדלת התנועה היומית. בין אם זה לעלות במדרגות במקום להשתמש במעלית, לבצע מתיחות בבוקר או לצאת להליכה קצרה אחרי ארוחות - כל צעד חשוב לבריאות טובה יותר.',
    },
    {
        key: 'article3_paragraph2_content',
        en: 'Nutrition also plays a crucial role in maintaining energy levels and preventing illness. Eating a balanced diet filled with colorful fruits and vegetables, lean proteins, and healthy fats helps keep your body strong. Reducing processed foods and added sugars can further support your immune system and overall health.',
        he: 'תזונה משחקת תפקיד מרכזי בשמירה על רמות האנרגיה ובמניעת מחלות. אכילת תזונה מאוזנת הכוללת פירות וירקות צבעוניים, חלבונים רזים ושומנים בריאים מסייעת לחיזוק הגוף. הפחתת מזון מעובד וסוכרים מוספים יכולה לתמוך עוד יותר במערכת החיסונית ובבריאות הכללית שלכם.',
    },
    {
        key: 'article3_paragraph3_content',
        en: 'One of the most important aspects of well-being is listening to your body. Paying attention to signs of stress, fatigue, or discomfort can help you make better health choices. Prioritizing rest, relaxation, and mindfulness will enhance both your physical and mental health, leading to a more balanced and fulfilling lifestyle.',
        he: 'אחד ההיבטים החשובים ביותר של הרווחה האישית הוא הקשבה לגוף. תשומת לב לסימני לחץ, עייפות או חוסר נוחות יכולה לעזור לכם לקבל החלטות בריאות טובות יותר. מתן עדיפות למנוחה, הרפיה ותשומת לב למצב הנפשי ישפרו הן את הבריאות הפיזית והן את הבריאות הנפשית שלכם, ויובילו לאורח חיים מאוזן ומספק יותר.',
    },

    {
        key: 'article4_title',
        en: 'Healthy Living Made Easy: Practical Tips for Everyday Wellness',
        he: 'אורח חיים בריא בפשטות: טיפים מעשיים לבריאות יומיומית',
    },
    {
        key: 'article4_paragraph1_content',
        en: 'Good health starts with small, consistent actions that support your body and mind. One of the simplest yet most effective ways to improve your well-being is to get enough quality sleep. Aim for at least 7-9 hours each night, as sleep is essential for energy, immune function, and mental clarity. Establishing a bedtime routine, such as limiting screen time before bed and keeping a regular sleep schedule, can help you rest better.',
        he: 'בריאות טובה מתחילה בפעולות קטנות ועקביות התומכות בגוף ובנפש. אחת הדרכים הפשוטות אך היעילות ביותר לשיפור הרווחה האישית היא הקפדה על שינה איכותית. שאפו לישון לפחות 7-9 שעות בלילה, שכן שינה חיונית לרמות האנרגיה, לתפקוד מערכת החיסון ולבהירות המחשבה. קביעת שגרת שינה, כמו הפחתת זמן מסך לפני השינה ושמירה על לוח זמנים קבוע, יכולה לשפר את איכות המנוחה שלכם.',
    },
    {
        key: 'article4_paragraph2_content',
        en: 'Hydration is another key factor in maintaining optimal health. Drinking enough water throughout the day helps regulate body temperature, support digestion, and keep your skin looking healthy. If you struggle to drink enough water, try infusing it with fresh fruits or setting reminders to take sips regularly. Proper hydration can make a noticeable difference in how you feel and function daily.',
        he: 'הידרציה היא גורם מפתח נוסף לשמירה על בריאות מיטבית. שתייה מספקת של מים במהלך היום מסייעת לוויסות טמפרטורת הגוף, לתמיכה בעיכול ולשמירה על עור בריא. אם קשה לכם לשתות מספיק מים, נסו להוסיף להם פירות טריים או להגדיר תזכורות לשתייה סדירה. שמירה על רמת נוזלים תקינה יכולה להשפיע באופן משמעותי על התחושה והתפקוד היומיומי שלכם.',
    },
    {
        key: 'article4_paragraph3_content',
        en: 'Wellness is not just about diet and exercise—it’s also about maintaining positive relationships and managing stress effectively. Surrounding yourself with supportive people and engaging in activities that bring you joy can greatly improve your mental health. Whether it’s spending time with loved ones, practicing deep breathing, or engaging in a hobby, these small steps contribute to a happier, healthier life.',
        he: 'רווחה אישית אינה מסתכמת רק בתזונה ופעילות גופנית – היא כוללת גם שמירה על מערכות יחסים חיוביות וניהול לחצים באופן יעיל. הקפת עצמכם באנשים תומכים ועיסוק בפעילויות שמסבות לכם אושר יכולים לשפר באופן משמעותי את בריאותכם הנפשית. בין אם מדובר בזמן איכות עם בני משפחה, תרגול נשימות עמוקות או עיסוק בתחביב אהוב, צעדים קטנים אלו תורמים לחיים מאושרים ובריאים יותר.',
    },
    {
        key: 'read_more',
        en: 'Read More',
        he: 'קרא עוד',
    },
    {
        key: 'latest_articles',
        en: 'Latest Articles',
        he: 'מאמרים אחרונים',
    },

    {
      key: 'question_1',
      en: 'Who can join "Mashlim"?',
      he: 'מי יכול להצטרף ל"משלים"?',
    },
    {
      key: 'answer_1',
      en: 'Everyone is welcome! No conditions or restrictions — anyone can join and enjoy our services.',
      he: 'כולם מוזמנים! אין סייגים או תנאים מוקדמים — כל אחד ואחת יכולים להצטרף וליהנות מהשירותים שלנו.',
    },
    {
      key: 'question_2',
      en: 'If I already have supplementary insurance from my HMO, do I still need this?',
      he: 'אם יש לי שב"ן של קופת חולים, האם יש טעם להצטרף?',
    },
    {
      key: 'answer_2',
      en: 'Absolutely! Mashlim provides services not covered by HMO insurances — such as home doctor visits, urgent care, advanced diagnostic tests, cancer screenings, and more.',
      he: 'בהחלט! "משלים" מעניק שירותים שלא כלולים בביטוחים של קופות החולים: רופא עד הבית, טיפולי חירום, בדיקות אבחנתיות מתקדמות, סקירות לגילוי מוקדם של סרטן ועוד.',
    },
    {
      key: 'question_3',
      en: 'I have private health insurance — should I cancel it when joining Mashlim?',
      he: 'יש לי ביטוח בריאות פרטי — האם כדאי לבטל אותו כשאני מצטרף?',
    },
    {
      key: 'answer_3',
      en: 'Not necessarily. Mashlim is not a health insurance and doesn’t replace it. However, it offers unique services like ambulance transport, screening tests, and special consultations that may not be included in private plans.',
      he: '"משלים" אינו ביטוח בריאות, ולכן לא מחליף ביטוח פרטי. אבל כן כולל שירותים רבים שלא תמיד ניתנים בביטוח — למשל: פינוי באמבולנס, בדיקות סקר, ייעוצים מיוחדים ועוד.',
    },
    {
      key: 'question_4',
      en: 'If I go to a private doctor, how fast will I get reimbursed?',
      he: 'פניתי לרופא פרטי – תוך כמה זמן אקבל החזר כספי?',
    },
    {
      key: 'answer_4',
      en: 'Reimbursement is processed within 72 hours, and in some cases, even within a few hours.',
      he: 'החזר מהיר – עד 72 שעות! ובחלק מהמקרים – ההחזר מועבר כבר תוך מספר שעות.',
    },
    {
      key: 'question_5',
      en: 'What’s included in the pregnancy benefits?',
      he: 'מה כלול בסל ההריון?',
    },
    {
      key: 'answer_5',
      en: 'The pregnancy package includes tests such as amniocentesis, chorionic villus sampling, nuchal translucency, and more. The extended package also includes childbirth preparation classes, post-birth recovery stay, and lactation consultations.',
      he: 'דיקור מי שפיר, סיסי שלייה, שקיפות עורפית ועוד. בסל ההריון המורחב תיהנו גם מקורס הכנה ללידה, שהות במלונית לאחר הלידה, ייעוץ עם יועצת הנקה ועוד.',
    },
    {
      key: 'question_6',
      en: 'Are periodic checkups included?',
      he: 'האם כלולות בדיקות תקופתיות?',
    },
    {
      key: 'answer_6',
      en: 'Yes! Every two years you’re eligible for a full physical exam, lab tests, prostate cancer screening (over age 40), colorectal cancer screening (over age 50), cardiac evaluation, vision test, lung function test, and hearing test by a speech therapist.',
      he: 'בדיקות תקופתיות אחת לשנתיים הכוללות: בדיקה גופנית מלאה, בדיקות דם ושתן, מעל גיל 40: בדיקה לסרטן הערמונית, מעל גיל 50: בדיקת צואה לגילוי מוקדם של סרטן המעי, בדיקת לב (קרדיולוגיה), בדיקות עיניים, שמיעה ותפקודי נשימה.',
    },
    {
      key: 'question_7',
      en: 'Is there any commitment when joining?',
      he: 'יש התחייבות כשנרשמים?',
    },
    {
      key: 'answer_7',
      en: 'Not at all! You can cancel at any time, with no cancellation fee or long-term commitment.',
      he: 'ממש לא. ניתן לבטל את ההצטרפות בכל עת, ללא התחייבות או קנס.',
    },
    {
      key: 'question_8',
      en: 'Who should I contact for urgent home doctor visits?',
      he: 'איך פונים לרופא עד הבית במקרה חירום?',
    },
    {
      key: 'answer_8',
      en: 'Just call us or message us on WhatsApp — we’re available 24/7 and will send a doctor quickly.',
      he: 'פשוט מתקשרים או כותבים לנו בוואטסאפ. אנחנו זמינים עבורכם 24/7 ונשלח רופא במהירות האפשרית.',
    },
    {
      key: 'question_9',
      en: 'How do I get reimbursed for a test I already paid for?',
      he: 'איך מקבלים החזר על בדיקה שכבר שולמה?',
    },
    {
      key: 'answer_9',
      en: 'Call us and our representatives will guide you through the reimbursement process. We recommend contacting us before the test — we may be able to arrange pre-payment.',
      he: 'פנייה פשוטה אלינו טלפונית מספיקה. נדריך אתכם בתהליך ההחזר. מומלץ ליצור קשר איתנו מראש – ייתכן שנוכל לדאוג לתשלום מראש מול הגורם המטפל.',
    },
    {
        key: 'faq_title',
        en: 'Frequently Asked Questions',
        he: 'שאלות נפוצות',
    },
    {
        key: 'get_answers',
        en: 'Get Answers to Your Questions',
        he: 'קבל תשובות לשאלות שלך',
    },

    {
      key: "testimonials_1_designation",
      he: "לאחר חיפושים רבים לרופא בתחום ספציפי, פניתי למשלים וקיבלתי תור תוך ימים ספורים. השירות היה מהיר, יעיל ומדויק. קיבלתי החזר כספי מיידי והרגשתי שיש מי שדואג לי באמת.",
      en: "After searching for a specialist, I turned to Mashlim and got an appointment within days. The service was fast, efficient, and accurate. I received a quick refund and truly felt supported.",
    },
    {
      key: "testimonials_1_name",
      he: "מאי לוי",
      en: "Yossi Levi",
    },
    {
      key: "testimonials_2_designation",
      he: "כאשר נדרשתי לבצע בדיקת MRI דחופה, משלים עזרו לי לאתר מכון איכותי ולקבל החזר של רוב העלות. לא הייתי מאמינה כמה קל זה יכול להיות. שירות שנותן שקט נפשי אמיתי.",
      en: "When I needed an urgent MRI, Mashlim helped me find a quality clinic and refunded most of the cost. I never imagined it could be this easy. True peace of mind.",
    },
    {
      key: "testimonials_2_name",
      he: "אורית כהן",
      en: "Orit Cohen",
    },
    {
      key: "testimonials_3_designation",
      he: "בשעת לילה מאוחרת בני הקטן חווה חום גבוה. תוך פחות משעה הרופא היה אצלנו בבית. בדק אותו, הרגיע אותנו ונתן טיפול במקום. שירות שפשוט הציל אותנו.",
      en: "Late at night my young son had a high fever. In less than an hour, a doctor arrived at our home. He examined him, calmed us, and treated on the spot. This service truly saved us.",
    },
    {
      key: "testimonials_3_name",
      he: "נועה דביר",
      en: "Noa Dvir",
    },
    {
      key: "testimonials_4_designation",
      he: "בתור הורה לילד שמתמודד עם אתגרי קשב, משלים עזרו לי לאבחן את הבעיה במקום מקצועי וללא עיכובים. האבחון היה מקיף, והצוות ליווה אותנו לאורך כל הדרך.",
      en: "As a parent of a child with attention difficulties, Mashlim helped me get a timely and professional diagnosis. The evaluation was thorough and the team supported us all the way.",
    },
    {
      key: "testimonials_4_name",
      he: "רון פרידמן",
      en: "Ron Friedman",
    },
    {
      key: "partners",
      en: "Partners",
      he: "שותפים",
    },
     {
      key: "search_member",
      en: "Search Member",
      he: "חפש מנוי"
    },
     {
      key: "status",
      en: "Status",
      he: "סטטוס"
    },
    {
      key: "gov_id_label",
      en: "Government ID",
      he: "תעודת זהות"
    },
    {
      key: "search",
      en: "Search",
      he: "חפש"
    },
    {
      key: "member_details",
      en: "Member Details",
      he: "פרטי המנוי"
    },
    {
      key: "active_subscription",
      en: "Active Subscription",
      he: "מנוי פעיל"
    },
      {
      key: "member_does_not_exist",
      en: "Member Does Not Exist",
      he: "המנוי לא קיים"
    },
    
    {
      key: "testimonials_5_designation",
      he: "לאחר שנים של כאבי גב, סוף סוף מצאתי מקום שמציע לי טיפולים איכותיים ובתנאים נוחים. משלים עזרו לי לקבוע תורים למרפאת כאב מקצועית, וקיבלתי החזר מכובד על כל טיפול.",
      en: "After years of back pain, I finally found a place offering quality treatments on flexible terms. Mashlim helped me book pain clinic sessions and I received fair refunds for each visit.",
    },
    {
      key: "testimonials_5_name",
      he: "גלית עמר",
      en: "Galit Amar",
    },
    {
        key: 'what_our_clients_say',
        en: 'What Our Customers Say',
        he: 'מה הלקוחות שלנו אומרים',
    },
    {
        key: 'testimonials',
        en: 'Testimonials',
        he: 'המלצות',
    },
    {
        key: 'work_with',
        en: 'Our Partners',
        he: 'עובדים עם כל לקוחות קופות החולים בישראל',
    },
    {
        key: 'address',
        en: '123 Fifth Avenue, New York, NY 10160, USA',
        he: 'תוצרת הארץ 3, פתח תקווה'
    },
    {
        key: 'phone',
        en: '03-3035753',
        he: '03-3035753'
    },
    {
        key: 'email',
        en: 'support@mashlim.org.il',
        he: 'support@mashlim.org.il',
    },
    {
        key: 'newsletter',
        en: 'Subscribe to Our Newsletter',
        he: 'הרשמה לניוזלטר שלנו',
    },
    {
        key: 'copy_right',
        en: 'Copyright © 2025 Mashlim. All Rights Reserved',
        he: '© כל הזכויות שמורות למשלים'
    },
    {
        key: 'subscribe_newsletter',
        en: 'Subscribe to our newsletter for the latest updates and offers',
        he: 'הרשמו לניוזלטר שלנו לעדכונים והצעות אחרונות'
    },
    {
        key: 'enter_email',
        en: 'Enter your email address',
        he: 'הזינו את כתובת האימייל שלכם'
    },
    {
        key: 'connect_with_us',
        en: 'Connect with Us',
        he: 'התחברו אלינו'
    },
    {
        key: 'how_it_works',
        en: 'How It Works',
        he: 'איך זה עובד'
    },
    {
        key: 'how_it_works_title',
        en: '4 easy steps to get your solution',
        he: 'בחר את הרופא הנכון עבורך, אנחנו נדאג להוצאות.'

    },
    {
        key: 'how_it_works_step1_title',
        en: 'Search for a Doctor',
        he: 'חפש רופא'
    },
    {
        key: 'how_it_works_step1_desc',
        en: 'Search for a doctor based on specialization, location, or availability',
        he: 'חפש רופא לפי התמחות, מיקום או זמינות'
    },
    {
        key: 'how_it_works_step2_title',
        en: 'Book an Appointment',
        he: 'קבע תור'
    },
    {
        key: 'how_it_works_step2_desc',
        en: 'Book an appointment online through our website or mobile app',
        he: 'כשאינך מוגבל לרופאים של הקופה, זה הרבה יותר מהר.'
    },
    {
        key: 'how_it_works_step3_title',
        en: 'Consult with a Doctor',
        he: 'היוועץ עם רופא'
    },
    {
        key: 'how_it_works_step3_desc',
        en: 'Have a virtual consultation with your doctor at the scheduled time',
        he: 'בסיום הפגישה עם הרופא שמור את הקבלה'
    },
    {
        key: 'how_it_works_step4_title',
        en: 'Get Your Prescription',
        he: 'קבל החזר כספי'
    },
    {
        key: 'how_it_works_step4_desc',
        en: 'Receive your prescription and follow your doctor’s advice for treatment',
        he: 'שלח לנו את הקבלה באימייל או וואטסאפ ואנחנו נדאג כבר להעביר לך את ההחזר'
    },
    {
        key: 'name',
        en: 'Name',
        he: 'שם'
    },
    {
        key: 'email_label',
        en: 'Email',
        he: 'אימייל'
    },
    {
        key: 'phone_label',
        en: 'Phone',
        he: 'טלפון'
    },
    {
        key: 'password_label',
        en: 'Password',
        he: 'סיסמה'
    },
    {
        key: 'or',
        en: 'or',
        he: 'או'
    },
    {
        key: 'sign_in_with_google',
        en: 'Sign in with Google',
        he: 'התחבר עם גוגל'
    },
    {
        key: 'sign_in_with_facebook',
        en: 'Sign in with Facebook',
        he: 'התחבר עם פייסבוק'
    },
    {
        key: 'dont_have_account',
        en: 'Don’t have an account?',
        he: 'אין לך חשבון?'
    },
    {
        key: 'already_have_account',
        en: 'Already have an account?',
        he: 'כבר יש לך חשבון?'
    },
    {
        key: 'send',
        en: 'Send',
        he: 'שלח'
    },
    {
        key: 'articles',
        en: 'Articles',
        he: 'מאמרים'
    },
    {
        key: 'tags',
        en: 'Tags',
        he: 'תגיות'
    },
    {
        key: 'happy_patients',
        en: 'Happy Patients',
        he: 'לקוחות מרוצים'
    },
    {
        key: 'doctor_to_the_house',
        en: 'Doctor to the House',
        he: 'רופא עד הבית'
    },
    {
        key: 'nurse_to_the_house',
        en: 'Nurse to the House',
        he: 'אחות עד הבית'
    },
    {
        key: 'medicine_at_home',
        en: 'Medicine at Home',
        he: 'רפואה עד הבית'
    },
    {
        key: 'our_services',
        he: 'כתבי השירות שלנו',
        en: 'Our Services'
    },
    {
        key: 'looking_for_private_doctor',
        en: 'Looking for a private doctor to visit you at home?',
        he: 'מחפש רופא פרטי שיבוא אליך הביתה?',
    },
    {
        key: 'get_professional_care',
        en: 'Get professional medical care 24/7, anywhere in the country!',
        he: 'קבל טיפול רפואי מקצועי 24/7, בכל מקום בארץ!',
    },
    {
        key: 'how_does_it_work',
        en: 'How does it work?',
        he: 'איך זה עובד?'
    },
    {
        key: 'need_a_doctor',
        en: 'Need a doctor?',
        he: 'צריך רופא מומחה?'
    },
    {
        key: 'call_us',
        en: 'Call us',
        he: 'צור קשר איתנו'
    },
    {
        key: 'checking_estimate_time',
        en: 'Checking the estimated time',
        he: 'אנו נבדוק את הזמן המשוער להגעה של הרופא לכתובת שלך'
    },
    {
        key: 'doctor_arrives',
        en: 'A professional doctor arrives at your home, provides treatment, prescribes medication if needed, and issues referrals.',
        he: 'רופא מקצועי מגיע לביתך, מספק טיפול, רושם תרופות במידת הצורך ומנפיק הפניות.',
    },
    {
        key: "question_pediatricians",
        en: "Do you have pediatricians?",
        he: "האם יש לכם רופאי ילדים?"
    },
    {
        key: "answer_pediatricians",
        en: "Our doctors are general practitioners trained to treat children from one year old and above.",
        he: "הרופאים שלנו הם רופאים כלליים המיומנים בטיפול בילדים מגיל שנה ומעלה."
    },
    {
        key: "question_payment",
        en: "How can I pay?",
        he: "איך ניתן לשלם?"
    },
    {
        key: "answer_payment",
        en: "We accept both credit card and cash payments.",
        he: "אנחנו מקבלים תשלומים בכרטיס אשראי."
    },
    {
        key: "question_health_fund_reimbursement",
        en: "Can I get a health fund reimbursement?",
        he: "האם ניתן לקבל החזר מקופת חולים?"
    },
    {
        key: "answer_health_fund_reimbursement",
        en: "Reimbursements depend on your health fund's policy. Contact them for details.",
        he: "החזרי תשלום תלויים במדיניות קופת החולים שלך. צור איתם קשר לפרטים נוספים."
    },
    {
        key: "question_specialist_doctors",
        en: "Do you have specialist doctors?",
        he: "האם יש לכם רופאים מומחים?"
    },
    {
        key: "answer_specialist_doctors",
        en: "We provide online specialist consultations starting from $480.",
        he: "צרו איתנו קשר ובדקו לגבי כל מומחיות. עלות הייעוץ המקוון מתחילה ב480 ש״ח לשיחה"
    },
    {
        key: "question_iv_treatment",
        en: "Can the doctor administer IV treatment at home?",
        he: "האם הרופא יכול לתת טיפול דרך הווריד בבית?"
    },
    {
        key: "answer_iv_treatment",
        en: "No, IV treatments require hospital facilities.",
        he: "לא, טיפולי IV דורשים מתקני בית חולים."
    },
    {
        key: "question_home_visits_viral_infections",
        en: "Do you provide home visits for patients with viral infections?",
        he: "האם אתם מספקים ביקורי בית לחולים עם זיהומים נגיפיים?"
    },
    {
        key: "answer_home_visits_viral_infections",
        en: "Unfortunately, we cannot send doctors to patients suspected of having highly contagious viral infections.",
        he: "לצערנו, איננו יכולים לשלוח רופאים למטופלים החשודים כחולים בזיהומים נגיפיים מדבקים מאוד."
    },
    {
        key: 'doctor_home_visit',
        en: 'Doctor Home Visit',
        he: 'ביקור רופא בבית'
    },
    {
        key: 'doctor_home_visit_desc',
        en: 'Home doctor visits provide an essential medical service, ensuring patients receive timely care without the need to visit a clinic or hospital. This service is especially beneficial for:',
        he: 'ביקורי רופא בבית מספקים שירות רפואי חיוני, הבטיחות שהמטופלים יקבלו טיפול בזמן בלי צורך לבקר במרפאה או בבית חולים. שירות זה מועיל במיוחד ל:'
    },
    {
        key: "elderly_patients",
        en: "Elderly patients",
        he: "מטופלים קשישים"
    },
    {
        key: "limited_mobility",
        en: "People with limited mobility",
        he: "אנשים עם ניידות מוגבלת"
    },
    {
        key: "flu_like_symptoms",
        en: "Those experiencing flu-like symptoms or mild illnesses",
        he: "אנשים עם תסמינים דמויי שפעת או מחלות קלות"
    },
    {
        key: "private_home_care",
        en: "Anyone who prefers private, immediate medical care in their home",
        he: "כל מי שמעדיף טיפול רפואי פרטי ומיידי בביתו"
    },
    {
        key: "when_to_order_doctor",
        en: "When to Order a Doctor?",
        he: "מתי להזמין רופא?"
      },
      {
        key: "non_emergency_condition",
        en: "If you have a non-emergency condition that requires medical attention.",
        he: "אם יש לך מצב שאינו חירום אך דורש תשומת לב רפואית."
      },
      {
        key:"add",
        en:"Add",
        he:"הוסף"
      },
      {
        key:"card_holder_name",
        en:"Card Holder Name",
        he:"שם בעל הכרטיס"
      },
      {
        key:"gov_id",
        en:"Government ID",
        he:"תעודת זהות"
      },
      {
        key:"card_number",
        en:"Card Number",
        he:"מספר כרטיס"
      },
      {
        key:"mother",
        en:"Mother",
        he:"אמא"
      },
      {
        key:"father",
        en:"Father",
        he:"אבא"
      },
      {
        key:"sister",
        en:"Sister",
        he:"אחות"
      },
      {
        key:"brother",
        en:"Brother",
        he:"אח"
      },

      {
        key:"son",
        en:"Son",
        he:"בן"
      },
      {
        key:"required",
        en:"Required",
        he:"שדה נדרש"
      },
      {
        key:"download",
        en:"Download",
        he:"הורד"
      },
      {
        key:"case_status.New",
        en:"New",
        he:"חדש"
      },

      {
        key: "case_status.Closed",
        en: "Closed",
        he: "סגור"
      },
      {
        key: "case_status.On Hold",
        en: "On Hold",
        he: "בהמתנה"
      },
      {
        key: "case_status.In Progress",
        en: "In Progress",
        he: "בתהליך"
      },
      {
        key: "case_status.Escalated",
        en: "Escalated",
        he: "הועלה לטיפול"
      },
      {
        key:"case_reason.Refund Claim",
        en:"Refund Claim",
        he:"תביעה להחזר"
      },
      {
        key:"case_type.Claim",
        en:"Claim",
        he:"תביעה"
      },
          {
        key:"case_type.Problem",
        en:"Problem",
        he:"בעיה"
      },
          {
        key:"case_type.Question",
        en:"Question",
        he:"שאלה"
      },
        {
        key:"case_type.field",
        en:"Case Type",
        he:"סוג פניה"
      },
       {
        key:"case_reason.field",
        en:"Case Reason",
        he:"סיבת הפניה"
      },
      
      
      {
        key:"my_cases",
        en:"My Cases",
        he:"הפניות שלי"
      },
    {
      key:"new_case",
      en:"New Case",
      he:"פניה חדשה"
    },
      {
        key:"case_reason.Other Request / Issue",
        en:"Other Request / Issue",
        he:"בקשה / בעיה אחרת"
      },
      {
        key:"case_reason.Doctor Home Visit Request",
        en:"Doctor Home Visit Request",
        he:"בקשה לביקור רופא בבית"
      },


      {
        key:"not allowed to be empty",
        en:"This field is not allowed to be empty",
        he:"שדה זה לא יכול להיות ריק"
      },
      {
        key:"forgot_password",
        en:"Forgot Password?",
        he:"שכחת סיסמה?"
      },
      {
        key:"reset_password",
        en:"Reset Password",
        he:"אפס סיסמה"
      },
      {
        key:"must be a valid email",
        en:"Must be a valid email",
        he:"אימייל לא תקין"
      },
      {
        key:"parent",
        en:"Parent",
        he:"הורה"
      },
      {
        key:"child",
        en:"Child",
        he:"ילד"
      },
      {
        key:"daughter",
        en:"Daughter",
        he:"בת"
      },
    
      {
        key:"other",
        en:"Other",
        he:"אחר"
      },
      {
        key:"select_relationship",
        en:"Select Relationship",
        he:"בחר קשר"
      },
      {
        key: "payment_method",
        en: "Payment Method",
        he: "שיטת תשלום"
      },
      {
        key:"thank_you",
        en:"Thank You!",
        he:"תודה!"
      },
      {
        key:"success_order",
        en:"Your order has been successfully placed.",
        he:"ההזמנה שלך בוצעה בהצלחה."
      },
      {
        key:"go_to_dashboard",
        en:"Go to Dashboard",
        he:"עבור לאיזור האישי"
      },
      {
        key:"expiry_date",
        en:"Expiry Date",
        he:"תוקף"
      },
    {
      key:"pay",
      en:"Pay",
      he:"שלם"
    },
    
      {
        key:"cvv",
        en:"CVV",
        he:"קוד CVV"
      },
      {
        key:"billing_address",
        en:"Billing Address",
        he:"כתובת חיוב"
      },
      {
        key:"city",
        en:"City",
        he:"עיר"
      },
      {
        key:"zip_code",
        en:"Zip Code",
        he:"מיקוד"
      },
      {
        key:"price",
        en:"Price",
        he:"מחיר"
      },
      {
        key:"total",
        en:"Total",
        he:"סך הכל"
      },
      {
        key:"cancel",
        en:"Cancel",
        he:"בטל"
      },
      {
        key:"edit",
        en:"Edit",
        he:"ערוך"
      },
      {
        key:"delete",
        en:"Delete",
        he:"מחק"
      },

      {
        key: "clinic_inconvenience",
        en: "When visiting a clinic is inconvenient or risky (e.g., to avoid exposure to illnesses in waiting rooms).",
        he: "כאשר ביקור במרפאה אינו נוח או מסוכן (למשל, כדי להימנע מחשיפה למחלות בחדרי המתנה)."
      },
      {
        key: "immediate_medical_advice",
        en: "For immediate medical advice and treatment without delays.",
        he: "לקבלת ייעוץ רפואי מיידי וטיפול ללא עיכובים."
      },
      {
        key:'or_signup_with',
        en:'Or sign up with',
        he:'או הרשם עם'
      },
      {
        key: "membership_title",
        en: "Join our membership program for exclusive benefits and reduced rates on home doctor visits!",
        he: "הצטרפו לתוכנית החברות שלנו כדי ליהנות מהטבות בלעדיות וממחירים מוזלים לביקורי רופא בבית!"
      },
      {
        key: "membership_priority",
        en: "Get priority service and discounted prices.",
        he: "קבלו שירות בעדיפות ומחירים מוזלים."
      },
      {
        key: "membership_quick_access",
        en: "Enjoy quick access to medical professionals anytime you need.",
        he: "תיהנו מגישה מהירה לאנשי מקצוע רפואיים בכל עת שתזדקקו."
      },
      {
        key: "membership_signup",
        en: "Sign up today and ensure premium healthcare at home!",
        he: "הירשמו עוד היום ותבטיחו שירותי בריאות פרימיום בבית!"
      },
      {
        key:'signup_now',
        en:'Sign Up Now',
        he:'הרשמו עכשיו'
      },
      {
        key:'private_nurse',
        en:'ooking for a private nurse to visit you at home?',
        he:'מחפש אחות פרטית שתבקר אותך בבית?'
      },
      {
        key:'get_professional_nursing_care',
        en:'Get professional nursing care 24/7, starting from just 195₪!',
        he:'קבל טיפול אחותי מקצועי 24/7'
      },
      {
        key:'nurse_home_visit_team_check',
        en:'Our team checks the estimated waiting time for a nurse to arrive at your location.',
        he:'הצוות שלנו בודק את הזמן המשוער להגעת האחות לכתובת שלך'
      },
      {
        key:'nurse_arrives',
        en:'A professional nurse arrives at your home for primary care, medical assistance, and support.',
        he:'אחות מקצועית מגיעה לביתך לטיפול ראשוני, סיוע רפואי ותמיכה.'
      },
      { 
        key: "question_1_services", 
        en: "What services do private nurses provide?", 
        he: "אילו שירותים מספקות אחיות פרטיות?" 
      },
      { 
        key: "answer_1_services", 
        en: "Home care services include wound care, injections, IV therapy, and post-surgical support.", 
        he: "שירותי טיפול ביתי כוללים טיפול בפצעים, זריקות, טיפול בעירוי ותמיכה לאחר ניתוח." 
      },
    
      { 
        key: "question_2_payment", 
        en: "How can I pay?", 
        he: "איך אפשר לשלם?" 
      },
      { 
        key: "answer_2_payment", 
        en: "Payments can be made by credit card or cash.", 
        he: "ניתן לשלם בכרטיס אשראי." 
      },
    
      { 
        key: "question_3_reimbursement", 
        en: "Can I get a health fund reimbursement?", 
        he: "האם אני יכול לקבל החזר מקופת החולים?" 
      },
      { 
        key: "answer_3_reimbursement", 
        en: "Reimbursements depend on your health fund’s policy. Contact them for more details.", 
        he: "החזר כספי תלוי במדיניות קופת החולים שלך. צור איתם קשר למידע נוסף." 
      },
    
      { 
        key: "question_4_hospice", 
        en: "Do nurses provide hospice care?", 
        he: "האם אחיות מספקות טיפול הוספיס?" 
      },
      { 
        key: "answer_4_hospice", 
        en: "Yes, we offer home hospice care, pain management, and emotional support for patients and families.", 
        he: "כן, אנו מציעים טיפול הוספיס ביתי, ניהול כאב ותמיכה רגשית לחולים ולמשפחותיהם." 
      },
    
      { 
        key: "question_5_iv_treatment", 
        en: "Can the nurse administer IV treatment at home?", 
        he: "האם האחות יכולה להעניק טיפול בעירוי בבית?" 
      },
      { 
        key: "answer_5_iv_treatment", 
        en: "Yes, our nurses can provide IV therapy and monitor treatment progress.", 
        he: "כן, האחיות שלנו יכולות להעניק טיפול בעירוי ולעקוב אחר התקדמות הטיפול." 
      },
    
      { 
        key: "question_6_viral_infections", 
        en: "Do you provide home visits for patients with viral infections?", 
        he: "האם אתם מספקים ביקורי בית לחולים עם זיהומים ויראליים?" 
      },
      { 
        key: "answer_6_viral_infections", 
        en: "Unfortunately, we cannot send nurses to patients suspected of having highly contagious viral infections.", 
        he: "לצערנו, איננו יכולים לשלוח אחיות למטופלים החשודים בזיהומים ויראליים מדבקים מאוד." 
      },
      {
        key: 'nurse_home_visit',
        en: 'Nurse Home Visit',
        he: 'ביקור אחות בבית'
    },
    {
        key: 'nurse_home_visit_desc',
        en: 'Home nursing care provides essential medical assistance in the comfort of your home. This service is especially beneficial for:',
        he: 'טיפול אחות בבית מספק סיוע רפואי חיוני בנוחות הבית. שירות זה מועיל במיוחד ל:'
    },
    {
        key: 'post_surgery_patients',
        en:'Post-surgery patients needing ongoing care',
        he:'מטופלים לאחר ניתוח שזקוקים לטיפול מתמיד'
    },
    {
        key:'chronic_illness_patients',
        en:'Individuals with mobility limitations',
        he:'אנשים עם הגבלות ניידות'
    },
    {
        key:'elderly_patients_nursing',
        en: 'Elderly patients requiring daily medical support',
        he: 'מטופלים קשישים שדורשים תמיכה רפואית יומית'
    },
    {
        key:'anyone_needing_nursing_care',
        en:'Anyone in need of professional nursing care without visiting a clinic or hospital',
        he:'כל מי שזקוק לטיפול אחותי מקצועי בלי לבקר במרפאה או בבית חולים'
    },
    {
        key: "when_to_order_nurse1",
        en: "For routine medical care such as injections, wound dressings, and IV therapy.",
        he: "לטיפול רפואי רגיל כגון זריקות, חבישות פצעים וטיפול בעירוי."
    },
    {
        key: "when_to_order_nurse2",
        en: "If you or a loved one need hospice or post-operative care at home.",
        he: "אם אתה או אדם קרוב זקוקים לטיפול הוספיס או טיפול לאחר ניתוח בבית."
    },
    {
        key: "when_to_order_nurse3",
        en: "When visiting a clinic is inconvenient or risky.",
        he: "כאשר ביקור במרפאה אינו נוח או מסוכן."
    },
    {
        key: "when_to_order_nurse4",
        en: "For ongoing monitoring and personalized care by a professional nurse.",
        he: "למעקב שוטף וטיפול אישי על ידי אחות מקצועית."
    },
    {
        key: "when_to_order_nurse",
        en: "When to Order a Nurse?",
        he: "מתי להזמין אחות?"
    },
    {
        key:'membership_priority_service',
        en:'Get priority service and reduced prices with our membership program!',
        he:'קבל שירות בעדיפות ומחירים מוזלים עם תוכנית החברות שלנו!',
    },
    {
        key:'membership_quick_access_nurses',
        en:'Access experienced nurses anytime you need them.',
        he:'גישה לאחיות מנוסות בכל עת שתזדקקו אליהן.'
    },
    {
        key:'membership_signup_nurses',
        en:'Sign up today for premium healthcare at home!',
        he:'הירשמו היום לשירותי בריאות פרימיום בבית!'
    },
    {
        key:'membership_title_nurses',
        en:'Join our membership program for exclusive benefits and discounted rates on home nursing services!',
        he:'הצטרפו לתוכנית החברות שלנו כדי ליהנות מהטבות בלעדיות וממחירים מוזלים לשירותי אחיות בבית!'
    },
    {
        key:'get_in_touch',
        en:'Get in Touch',
        he:'צרו קשר'
    },
    {
        key:'have_any_questions',
        en:'Have any questions or need help?',
        he:'יש לכם שאלות או צריכים עזרה?'
    },
    {
        key:'address_label',
        en:'Address',
        he:'כתובת'
    },
    {
      key:"you_have_chosen",
      en:"You have chosen",
      he:"בחרת במסלול:"
    },
    {
      key:"choose_a_plan",
      en:"Choose a plan",
      he:"בחר מסלול"
    },
    {
      key:"continue",
      en:"Continue",
      he:"המשך"
    },
    {
      key:"additional_info_desc",
      en:"Please provide update and fill in missing information",
      he:"אנא עדכן את הפרטים החסרים"
    },
    {
      key:"family_info_desc",
      en:"Please provide your family members' information",
      he:"אנא עדכן את פרטי בני המשפחה שתרצה להוסיף לשירות"
    },
    {
      key:"add_child",
      en:"Add child",
      he:"הוסף ילד"
    },
    {
      key:"continue",
      en:"Continue",
      he:"המשך"
    },
    {
      key:"add_spouse",
      en:"Add spouse",
      he:"הוסף בן/בת זוג"
    },
    {
      key:"update_your_info",
      en:"Update your information",
      he:"עדכן פרטים אישיים"
    },
    {
      key:"add_family_members",
      en:"Add family members",
      he:"הוסף בני משפחה"
    },
    {
      key:"payment",
      en:"Payment",
      he:"תשלום"
    },
    {
        key: "service_title_mushlam_briut",
        en: "Mushlam Briut Service Plan",
        he: "משלים בריאות"
      },
      {
        key: "service_desc_mushlam_briut",
        en: "A comprehensive health service plan providing medical consultations, diagnostic tests, preventive care, and more.",
        he: "תוכנית שירות רפואית מקיפה המספקת ייעוצים רפואיים, בדיקות אבחנתיות, רפואה מונעת ועוד."
      },
      {
        key:'and_more',
        en:'and more',
        he:'...ועוד'
      },
    
      // Benefits (General Explanation)
      {
        key: "service_benefit_1_mushlam_briut",
        en: "Covers consultations with medical specialists for various health concerns.",
        he: "כולל התייעצות עם רופאים מומחים בנושאים רפואיים שונים."
      },
      {
        key: "service_benefit_2_mushlam_briut",
        en: "Provides reimbursement for diagnostic tests based on medical necessity.",
        he: "מעניק החזר עבור בדיקות אבחנתיות בהתאם לצורך רפואי."
      },
      {
        key: "service_benefit_3_mushlam_briut",
        en: "Includes preventive medicine services such as routine health screenings.",
        he: "כולל שירותי רפואה מונעת כגון בדיקות סקר תקופתיות."
      },
      {
        key: "service_benefit_4_mushlam_briut",
        en: "Offers coverage for physiotherapy treatments with certified professionals.",
        he: "מספק כיסוי לטיפולי פיזיותרפיה עם מטפלים מוסמכים."
      },
      {
        key: "service_benefit_5_mushlam_briut",
        en: "Supports pregnancy-related tests and screenings for expectant mothers.",
        he: "תומך בבדיקות הריון ובדיקות סקר לנשים בהיריון."
      },
      {
        key: "service_benefit_6_mushlam_briut",
        en: "Provides access to 24/7 online doctor consultations for immediate medical advice.",
        he: "מאפשר ייעוץ עם רופא אונליין 24/7 למתן הכוונה רפואית מיידית."
      },
      {
        key: "service_benefit_7_mushlam_briut",
        en: "Includes the option for a home doctor visit when necessary.",
        he: "כולל אפשרות לביקור רופא בבית במקרה הצורך."
      },
      {
        key: "service_benefit_8_mushlam_briut",
        en: "Covers emergency ambulance transport to the nearest hospital when required.",
        he: "מכסה פינוי חירום באמבולנס לבית החולים הקרוב בעת הצורך."
      },

      {
        key: "service_title_mushlam_plus",
        en: "Mushlam Plus Service Plan",
        he: "משלים פלוס"
      },
      {
        key: "service_desc_mushlam_plus",
        en: "An extended health service plan offering additional medical services, specialized treatments, and enhanced reimbursements.",
        he: "תוכנית שירות רפואית מורחבת המספקת שירותים רפואיים נוספים, טיפולים מתקדמים והחזרים מוגדלים."
      },
    
      // Benefits (General Explanation)
      {
        key: "service_benefit_1_mushlam_plus",
        en: "Provides access to pain clinics for specialized treatments and pain management.",
        he: "מספק גישה למרפאות כאב לקבלת טיפולים מתקדמים וניהול כאב."
      },
      {
        key: "service_benefit_2_mushlam_plus",
        en: "Offers diagnostic evaluations for attention and concentration disorders in children.",
        he: "כולל אבחונים לאיתור בעיות קשב וריכוז אצל ילדים."
      },
      {
        key: "service_benefit_3_mushlam_plus",
        en: "Covers advanced endoscopic capsule imaging for internal medical evaluations.",
        he: "מעניק כיסוי לבדיקת קפסולה אנדוסקופית להדמיית מערכת העיכול."
      },
      {
        key: "service_benefit_4_mushlam_plus",
        en: "Supports sleep laboratory tests for diagnosing sleep disorders.",
        he: "מספק תמיכה בבדיקות במעבדת שינה לאבחון הפרעות שינה."
      },
      {
        key: "service_benefit_5_mushlam_plus",
        en: "Includes food intolerance tests for detecting sensitivities to specific foods.",
        he: "כולל בדיקות לאי-סבילות למזון לזיהוי רגישויות למזונות מסוימים."
      },
      {
        key: "service_benefit_6_mushlam_plus",
        en: "Expands pregnancy-related benefits with additional screenings and reimbursements.",
        he: "מרחיב את הזכאות לבדיקות הריון עם כיסוי נוסף והחזרים מוגדלים."
      },
      {
        key: "service_benefit_7_mushlam_plus",
        en: "Provides coverage for birth preparation courses to support expecting parents.",
        he: "מספק כיסוי לקורסי הכנה ללידה לתמיכה בהורים מצפים."
      },
      {
        key: "service_benefit_8_mushlam_plus",
        en: "Supports certified doula services during labor and birth.",
        he: "כולל תמיכה בשירותי דולה מוסמכת במהלך הלידה."
      },
      {
        key: "service_benefit_9_mushlam_plus",
        en: "Covers post-birth stay in maternity hotels for recovery and support.",
        he: "מעניק כיסוי לשהייה במלונית לאחר לידה לצורך התאוששות וליווי."
      },
      {
        key: "service_benefit_10_mushlam_plus",
        en: "Includes lactation consultation services with certified specialists.",
        he: "מספק שירותי ייעוץ הנקה עם מומחיות מוסמכות."
      },
      {
        key: "service_title_mushlam_at_home",
        en: "Mushlam At Home Service Plan",
        he: "משלים עד הבית"
      },
      {
        key: "service_desc_mushlam_at_home",
        en: "A specialized health service plan offering medical consultations, home visits, and emergency assistance at home.",
        he: "תוכנית שירות רפואית ייחודית המספקת ייעוץ רפואי, ביקורי בית וסיוע חירום בבית."
      },
    
      // Benefits (General Explanation)
      {
        key: "service_benefit_1_mushlam_at_home",
        en: "Provides 24/7 access to online doctor consultations for immediate medical advice.",
        he: "מספק גישה 24/7 לייעוץ עם רופא אונליין למתן הכוונה רפואית מיידית."
      },
      {
        key: "service_benefit_2_mushlam_at_home",
        en: "Includes home doctor visits for in-person medical examinations when necessary.",
        he: "כולל ביקורי רופא בבית לבדיקה רפואית פיזית בעת הצורך."
      },
      {
        key: "service_benefit_3_mushlam_at_home",
        en: "Offers medical guidance and prescription services through remote consultations.",
        he: "מספק הכוונה רפואית ושירותי מרשמים דרך ייעוץ מרחוק."
      },
      {
        key: "service_benefit_4_mushlam_at_home",
        en: "Covers emergency ambulance transport for urgent medical situations.",
        he: "מכסה פינוי חירום באמבולנס למצבים רפואיים דחופים."
      },
      {
        key: "service_benefit_5_mushlam_at_home",
        en: "Provides priority medical support for non-hospital urgent care needs.",
        he: "מספק תמיכה רפואית מיידית לצרכים דחופים שאינם דורשים אשפוז."
      },
      {
        key:'services',
        en:'Services Plans',
        he:'כתבי שירות'
      },
      {
        key:'show_more',
        en:'Show More',
        he:'הצג עוד'
      },
      {
        key:'show_less',
        en:'Show Less',
        he:'הסתר'
      },
      {
        key:'view_details',
        en:'View Details',
        he:'הצג פרטים'
      },
      {
        key:'join_now',
        en:'Join Now',
        he:'הצטרף עכשיו'
      },
      {
        key:'what_is_included',
        en:'What\'s Included',
        he:'מה כלול'
      },
      {
        key: 'go_back',
        en: '⬅️ Go Back',
        he: '→ חזור'
      },
      {
        key:'login_with_password',
        en:'Login with Password',
        he:'התחבר עם סיסמה'
      },
      {
        key:'login_with_otp',
        en:'Login with OTP',
        he:'התחבר עם קוד אימות'
      },
      {
        key:'girl',
        en:'Girl',
        he:'בת'
      },
      {
        key:'boy',
        en:'Boy',
        he:'בן'
      },
      {
        
        key:'months',
        en:'Months',
        he:'חודשים'
      },
      {
        key:'and',
        en:'and',
        he:'ו-'
      },
      {
        key:'male',
        en:'Male',
        he:'זכר'
      },
      {
        key:'female',
        en:'Female',
        he:'נקבה'
      },
      {
        key:'appointments',
        en:'Appointments',
        he:'תורים'
      },
      {
        key:'appointment',
        en:'Appointment',
        he:'תור חדש'
      },
      {
        key:'my_appointments',
        en:'My Appointments',
        he:'התורים שלי'
      },
      {
        key:'my_family',
        en:'My Family',
        he:'המשפחה שלי'
      },
      {
        key:'invoices',
        en:'Invoices',
        he:'חשבוניות'
      },
      {
        key:'settings',
        en:'Settings',
        he:'הגדרות'
      },
      {
        key:'logout',
        en:'Logout',
        he:'התנתק'
      },
      {
        key:"cases",
        en:"Cases",
        he:"פניות"
      },
       {
        key:"new_case",
        en:"New Case",
        he:"פניה חדשה"
      },
      { 
        key:"create",
        en:"Create",
        he:"צור"
      },
       { 
        key:"successfully_registered",
        en:"Successfully Registered",
        he:"נרשמת בהצלחה"
      },
      
      {
        key:'messages',
        en:'Messages',
        he:'הודעות'
      },
      {
        key:'dashboard',
        en:'Dashboard',
        he:'ראשי'
      },
      {
        key:'notifications',
        en:'Notifications',
        he:'התראות'
      },
      {
        key:'view_all',
        en:'View All',
        he:'הצג הכל'
      },
      {
        key:'booke_a_new',
        en:'Book a New',
        he:'קביעת'
      },
      {
        key:'no_notifications',
        en:'No notifications',
        he:'אין התראות'
      },
      {
        key:'phone_otp',
        en:'Phone OTP',
        he:'קוד אימות'
      },
      {
        key:'otp_sent_to_mobile',
        en:'OTP sent to your mobile number',
        he:'קוד אימות נשלח למספר הנייד שלך'
      },
      {
        key:'didnt_get_otp',
        en:'Didn\'t get OTP?',
        he:'לא קיבלת קוד?'
      }, 
      {
        key:'resend_code',
        en:'Resend Code',
        he:'שלח שוב'
      },
      {
        key:'secs',
        en:'secs',
        he:'שניות'
      },
      {
        key:'update_phone',
        en:'Update Phone',
        he:'עדכן טלפון נייד'
      },
      {
        key:'submit',
        en:'Submit',
        he:'שלח'
      },
      {
        key:'no_family_members',
        en:'No family members',
        he:'אין חברי משפחה' 
      },
      {
        key:'activate',
        en:'Activate',
        he:'הפעל'
      },
      {
        key:'deactivate',
        en:'Deactivate',
        he:'השבת'
      },
    {
        key: 'pending',
        en: 'Pending',
        he: 'ממתין',
    },
    {
        key: 'approved',
        en: 'Approved',
        he: 'מאושר',
    },
    {
        key: 'rejected',
        en: 'Rejected',
        he: 'נדחה',
    },
    {
        key: 'completed',
        en: 'Completed',
        he: 'הושלם',
    },
    {
        key: 'cancelled',
        en: 'Cancelled',
        he: 'בוטל',
    },
    {
        key:'waiting_for_doc_assignment',
        en:'Waiting for Doctor Assignment',
        he:'ממתין לשיוך רופא'
    },
    {
        key:'cancel',
        en:'Cancel',
        he:'בטל'
    },
    {
        key:'invoice_id',
        en:'Invoice ID',
        he:'מספר חשבונית'
    },
    {
        key:'description',
        en:'Description',
        he:'תיאור'
    },
    {
        key:'amount',
        en:'Amount',
        he:'סכום'
    },
    {
        key:'issued_on',
        en:'Issued On',
        he:'נפתחה בתאריך'
    },
    {
        key:'action',
        en:'Action',
        he:'פעולה'
    },
    {
        key:'personal_info',
        en:'Personal Information',
        he:'פרטים אישיים'
    },
    {
        key:'no_appointments',
        en:'No Appointments',
        he:'אין תורים'
    },
    {
        key:'personal_area',
        en:'Personal Area',
        he:'אזור אישי'
    },
    {
        key:'email_or_phone_label',
        en:'Email or Phone',
        he:'אימייל או טלפון'
    },
    {
        key: "article5_title",
        en: "Doctor at Home – A Critical Service for Every Household",
        he: "רופא עד הבית – פתרון רפואי חיוני בזמני משבר ושגרה"
      },
      {
        key: "article5_paragraph1_content",
        en: "It's no secret that hospitals in Israel are overcrowded, queues are long, and the treatment experience isn’t always ideal. In a time when time is a valuable resource and the need for accessible medical care grows — a doctor-at-home service becomes not just convenient, but vital.",
        he: "אין זה סוד שבתי החולים בישראל מתמודדים עם עומסים כבדים, תורים בלתי נגמרים ולעיתים גם חוויית טיפול לא אידאלית. בעידן שבו זמן הוא משאב יקר, והצורך בקבלת שירות רפואי איכותי וזמין רק הולך וגובר – שירות רופא עד הבית הופך לפתרון לא רק נוח, אלא לעיתים קרובות גם חיוני."
      },
      {
        key: "article5_paragraph2_content",
        en: "The service provided by 'Mushlam Bishvilcha' enables you to receive a certified doctor at your doorstep — without long waits, unnecessary exposure to infections, or second-guessing whether you're well enough to leave the house.",
        he: "השירות שמציעה תוכנית \"משלים עד הבית\" מאפשר לכם לקבל רופא מוסמך עד פתח הבית, בלי לחכות בתור, בלי להיחשף לזיהומים מיותרים ובלי להתחבט בשאלה אם באמת כדאי לצאת מהבית במצבכם הבריאותי."
      },
      {
        key: "article5_paragraph3_title",
        en: "Overburdened System? Here's the Solution",
        he: "עומס במערכת הבריאות? יש פתרון"
      },
      {
        key: "article4_paragraph3_content",
        en: "Hospitals today are overwhelmed. Waiting times can last for hours even in non-emergency cases. A doctor arriving quickly at home can prevent health deterioration and offer timely care in the right setting.",
        he: "המציאות כיום היא שבתי החולים עמוסים לעייפה. זמן ההמתנה לקבלת טיפול רפואי עשוי לארוך שעות ארוכות, גם כשמדובר במקרים שאינם דורשים אשפוז מיידי. ישנם מקרים בהם הגעה מהירה של רופא מקצועי עד הבית יכולה למנוע הדרדרות במצב הבריאותי ולספק את המענה המתאים בזמן הנכון, במקום הנכון."
      },
      {
        key: "article5_paragraph4_content",
        en: "Even the HMOs can't always help — days- or weeks-long queues, limited specialist availability, and rigid operating hours are common. In this reality, a medical professional arriving at your home changes everything.",
        he: "גם בקופות החולים עצמן לא תמיד המצב מזהיר – תורים של ימים או אפילו שבועות, זמינות נמוכה של רופאים מומחים, ולעיתים גם חוסר גמישות בזמני קבלת הקהל. בתוך כל זה, שירות רפואי שמגיע עד אליך – בזמינות גבוהה ובליווי אנשי מקצוע – משנה את כללי המשחק."
      },
      {
        key: "article5_paragraph5_title",
        en: "Health Protection – Not Just Time Saving",
        he: "לא רק חיסכון בזמן – גם הגנה על הבריאות"
      },
      {
        key: "article5_paragraph5_content",
        en: "Every trip outside — especially in winter or during outbreaks — exposes you to risks. At-risk groups like immunocompromised individuals, pregnant women, and elderly people benefit most from home care.",
        he: "כל יציאה מהבית, במיוחד בעונות החורף או בתקופות של התפרצות מחלות ויראליות, חושפת אתכם לסיכונים מיותרים. מדובר בעיקר על קבוצות סיכון – אנשים עם מערכת חיסון מוחלשת, חולים כרוניים, נשים בהריון, תינוקות וקשישים – שחשיפה לזיהום כלשהו עלולה לעלות ביוקר."
      },
      {
        key: "article5_paragraph6_content",
        en: "COVID-19 highlighted the importance of home medical care. For many, going to a clinic was no longer an option — the ability to receive treatment at home became essential.",
        he: "מגפת הקורונה הייתה עבור רבים קריאת השכמה – פתאום הבנו כמה חשוב להחזיק באופציה לקבלת טיפול רפואי ללא יציאה מהבית, במיוחד במקרים שבהם עצם ההגעה למרפאה מהווה סיכון."
      },
      {
        key: "article5_paragraph7_title",
        en: "Comfort and Security – In Your Own Space",
        he: "זמינות, נוחות וביטחון – הכל בבית שלך"
      },
      {
        key: "article5_paragraph7_content",
        en: "Doctor-at-home services offer complete medical attention — diagnosis, exams, prescriptions — all from the comfort of your home, with personal attention and minimized exposure.",
        he: "השירות של רופא עד הבית מביא איתו את כל היתרונות שבטיפול רפואי – אבחון מקצועי, בדיקה גופנית, מתן מרשמים, הנחיות להמשך טיפול ולעיתים גם ביצוע בדיקות בסיסיות – מבלי שתצטרכו לזוז מהספה."
      },
      {
        key: "article5_paragraph8_content",
        en: "Home visits also let doctors see the bigger picture — how you live, what might affect your health — leading to more accurate and personalized treatment.",
        he: "מעבר לכך, עצם קבלת הטיפול במרחב הפרטי שלכם מאפשר לרופא לראות את האדם כחלק מהקשר חייו, ולהעניק טיפול מדויק ומותאם יותר."
      },
      {
        key: "article5_paragraph9_title",
        en: "We're Here for You – Even in the Toughest Moments",
        he: "אנחנו כאן בשבילך – גם ברגעים הכי קשים"
      },
      {
        key: "article5_paragraph9_content",
        en: "At 'Mushlam Bishvilcha' we’re committed to giving you not just professional service, but also accessible, compassionate care — any time, anywhere.",
        he: "ב\"משלים עד הבית\" אנו מאמינים שהשירות הרפואי שאתה מקבל צריך להיות לא רק מקצועי – אלא גם נגיש, אישי ואמפתי."
      },
      {
        key: "article5_paragraph10_content",
        en: "Don’t wait in line. Don’t risk unnecessary exposure. Get the care you need, at home, with full respect and professionalism.",
        he: "אל תחכה בתור, אל תחשוף את עצמך שלא לצורך – תן לנו להגיע עד אליך, ולספק לך טיפול רפואי איכותי ומכבד, מתי שצריך ואיפה שנוח לך."
      },
      {
        key:'home_medicare',
        en:'Home Medicare',
        he:'רפואה עד הבית'
      },
      {
        key: "article6_title",
        en: "Complementary Medicine – Treating the Person, Not Just the Illness",
        he: "רפואה משלימה – לטפל באדם, לא רק במחלה"
      },
      {
        key: "article6_paragraph1_content",
        en: "Modern medicine is evolving rapidly, yet more and more people are looking for care beyond conventional treatments. Complementary medicine offers a holistic approach that places the person, not just the disease, at the center.",
        he: "העולם הרפואי של היום מתפתח במהירות, אך יחד עם הקדמה והטכנולוגיה, יותר ויותר אנשים פונים לחפש טיפול מעבר לרפואה הקונבנציונלית. כאן נכנסת לתמונה הרפואה המשלימה – גישה הוליסטית שמעמידה את האדם במרכז, לא רק את הסימפטום או המחלה."
      },
      {
        key: "article6_paragraph2_content",
        en: "As its name implies, complementary medicine complements conventional care. It considers the whole person — body, mind, and lifestyle. A patient is not just asked about physical symptoms, but also about sleep, nutrition, daily stress, and emotional wellbeing.",
        he: "רפואה משלימה כשמה כן היא – משלימה את הרפואה הקלאסית ולא מחליפה אותה. היא מתייחסת לאדם כמכלול של גוף, נפש, תודעה ואורח חיים. מטופל שמגיע למטפל ברפואה משלימה לא נשאל רק על כאבים פיזיים, אלא גם על הרגלי השינה שלו, תזונה, סטרס יומיומי, מצב רגשי ודפוסי התנהגות."
      },
      {
        key: "article6_paragraph3_title",
        en: "Prevention Is Also a Form of Healing",
        he: "לא רק טיפול – אלא גם מניעה"
      },
      {
        key: "article6_paragraph3_content",
        en: "One of the strengths of complementary medicine is identifying early imbalance patterns — physically, emotionally, or mentally — that may later develop into illness. This makes it not just a healing tool, but a preventive one as well.",
        he: "אחד היתרונות המשמעותיים של הרפואה המשלימה הוא היכולת לזהות דפוסים מוקדמים של חוסר איזון – פיזי, רגשי או מנטלי – אשר עשויים בעתיד להתפתח למחלה. בכך, רפואה זו פועלת לא רק לריפוי אלא גם למניעה."
      },
      {
        key: "article6_paragraph4_content",
        en: "For chronic conditions too, complementary medicine can provide support and relief. Treatments like acupuncture, shiatsu, reflexology, homeopathy, and naturopathy improve symptoms and restore mind-body balance.",
        he: "גם במקרים של מחלות כרוניות, הרפואה המשלימה מציעה תמיכה והקלה משמעותית. טיפולים כמו דיקור סיני, שיאצו, רפלקסולוגיה, הומאופתיה, נטורופתיה ועוד – יכולים להקל על תסמינים, לשפר את איכות החיים ולספק איזון שגוף ונפש זקוקים לו."
      },
      {
        key: "article6_paragraph5_title",
        en: "A Full-Body Experience",
        he: "לגוף, לנפש ולחיים עצמם"
      },
      {
        key: "article6_paragraph5_content",
        en: "Complementary medicine looks at how systems interact within the body and how they’re influenced by emotional states. It treats digestion issues, anxiety, migraines, sleep disturbances, and more — often with results where medications fall short.",
        he: "הייחוד של רפואה משלימה הוא שהיא אינה מתמקדת רק בבעיה, אלא במערכת היחסים שבין חלקי הגוף, ובחיבור בינם לבין מצבו הרגשי של האדם. טיפולים רבים מתמקדים באיזון מערכות פנימיות כמו מערכת העיכול, הנשימה והעצבים, ובמקביל מטפלים בחרדות, מתחים, עייפות מתמשכת, מיגרנות, בעיות שינה ועוד."
      },
      {
        key: "article6_paragraph6_content",
        en: "A balanced body heals itself better. By restoring internal physical and emotional balance, we activate the body’s natural healing powers and reduce the chance of future illness.",
        he: "אחת התובנות המרכזיות בתחום היא שגוף מאוזן הוא גוף שמרפא את עצמו טוב יותר. כלומר, על ידי איזון פנימי – רגשית, אנרגטית ופיזית – ניתן להפעיל את כוחות הריפוי הטבעיים של הגוף, ובכך לזרז החלמה או למנוע מחלות עתידיות."
      },
      {
        key: "article6_paragraph7_title",
        en: "For Every Age, At Every Stage",
        he: "מתאים לכל גיל, בכל שלב בחיים"
      },
      {
        key: "article6_paragraph7_content",
        en: "Complementary therapies are suitable for everyone — infants, children, pregnant women, adults, and the elderly. They are usually non-invasive, gentle, and free of side effects.",
        he: "יתרון חשוב נוסף של הרפואה המשלימה הוא היותה מתאימה לכולם. תינוקות הסובלים מגזים או קשיי שינה, ילדים עם בעיות ריכוז וחרדה, נשים בהריון, מבוגרים עם כאבים כרוניים ואפילו קשישים המחפשים חיזוק כללי – כולם יכולים להיעזר בטיפולים אלו ולהפיק מהם תועלת רבה."
      },
      {
        key: "article6_paragraph8_content",
        en: "These treatments are not invasive, don’t rely on chemicals, and are usually free of side effects — making them especially safe and comfortable.",
        he: "הרפואה המשלימה אינה פולשנית, אינה מבוססת על כימיקלים, ולרוב גם אינה כרוכה בתופעות לוואי – דבר שהופך אותה לאופציה בטוחה ונעימה במיוחד."
      },
      {
        key: "article6_paragraph9_title",
        en: "Integrative Medicine – A Winning Combination",
        he: "שילוב מנצח – יד ביד עם הרפואה המודרנית"
      },
      {
        key: "article6_paragraph9_content",
        en: "Today, many hospitals and clinics in Israel incorporate complementary medicine into their care systems. Doctors often recommend it alongside medication, or as a natural alternative for long-term support.",
        he: "בשנים האחרונות יותר ויותר מוסדות רפואיים בישראל משלבים רפואה משלימה כחלק אינטגרלי ממערך הטיפול שלהם. רופאים רבים ממליצים על טיפולים אלה כחיזוק לצד התרופות, או כחלופה טבעית למי שמעדיף להימנע משימוש בתרופות לאורך זמן."
      },
      {
        key: "article6_paragraph10_content",
        en: "Complementary medicine is more than just a treatment — it’s a worldview. If you're seeking healing, relaxation, or renewed energy, this path may offer just what you need.",
        he: "בסופו של דבר, רפואה משלימה היא הרבה יותר מטיפול – זו תפיסת עולם. היא מזכירה לנו שהבריאות שלנו תלויה לא רק בגנטיקה או במזל, אלא גם בדרך שבה אנחנו חיים, נושמים, חושבים ומרגישים."
      },
      {
        key:'complementary_medicine',
        en:'Complementary Medicine',
        he:'רפואה משלימה'
      },
      {
        key:'starting_from',
        en:'Starting from',
        he:'החל מ'
      },
      {
        key:'privacy',
        en:'Privacy Policy',
        he:'מדיניות פרטיות ותנאי שימוש'
      },
      {
        key:'privacy',
        en:'Privacy Policy',
        he:'מדיניות פרטיות ותנאי שימוש'
      },
      {
        key:'homepage',
        en:'Homepage',
        he:'דף הבית'
      },
      {
        key:"read_and_agree",
        en: "I have read and agree to",
        he: "קראתי ואני מסכים  "
      },
       {
        key:"terms_and_privacy",
        en: "Terms of Service and Privacy Policy",
        he: "לתנאי השירות ומדיניות הפרטיות"
      },
      {
        key:"contract_services_terms",
        en: "Contract Services Terms",
        he: "ולתנאי כתבי השירות"
      },
      {
        key:'approve_terms_error',
        en:'Please approve the terms of service and privacy policy',
        he:'אנא אשר את תנאי השירות'
      },
      {
        key:"site_map",
        en: "Site Map",
        he: "מפת האתר"
      }
      




];

